import { get, post } from '@/request/request'

export default {
    /**
     * 列表
     */
    list(params) {
        return get('/admin/bank/branches/list', params)
    },
    /**
     * 新增/编辑
     */
    saveData(params) {
        return post('/admin/bank/branches/save', params)
    },
    /**
     * 批量添加
     */
    multipleAdd(params){
        return post('/admin/bank/branches/multiple/add', params)
    },
    /**
     * 删除/批量删除
     */
    deleteData(params) {
        return post('/admin/bank/branches/delete', params)
    },
}